import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const api = new API(BASE_URL);

class ContractService {
  static fetchContracts = (body, params) => api.post(urls.CONTRACTLISTING.CONTRACTS, body, params);

  static fetchContract = id => api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL, id);

  static fetchContractPma = id => api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL_PMA, id);

  static fetchContractPmaBuildings = (id, parms = { page: 0, size: 5 }) =>
    api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL_PMA_BUILDINGS, id, parms);

  static fetchContractPmaBuildingUnits = (contractId, buildingId) =>
    api.get(`${urls.CONTRACTLISTING.CONTRACT_DETAIL_PMA_BUILDING_UNITS}/${contractId}/${buildingId}`);

  static verifyContract = id => api.get(`${urls.CONTRACTLISTING.VERIFY_CONTRACT}/${id}`);

  static fetchContractTypes = params => api.get(urls.CONTRACTLISTING.CONTRACT_TYPES, null, params);

  static fetchContractsOffPlan = (body, params) =>
    api.post(urls.CONTRACTLISTING.CONTRACT_LISTING_OFFPLAN, body, params);

  static fetchContractOffPlan = id => api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL_OFFPLAN, id);

  static fetchContractsMusataha = (body, params) =>
    api.post(urls.CONTRACTLISTING.CONTRACT_LISTING_MUSATAHA, body, params);

  static fetchContractsMortgage = body => api.post(urls.CONTRACTLISTING.CONTRACT_LISTING_MORTGAGE, body, null);

  static fetchMustahaLandUse = id => api.get(urls.CONTRACTLISTING.MUSATAHA_LAND_USE, id);

  static fetchContractMusataha = id => api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL_MUSATAHA, id);

  static fetchContractsPoa = (body, params) => api.post(urls.CONTRACTLISTING.POA_CONTRACT_LIST, body, params);

  static fetchContractMusatahaIndividual = id => api.get(urls.CONTRACTLISTING.CONTRACT_DETAIL_MUSATAHA_INDIVIDUAL, id);

  // Get Lease Properties in case multiple units
  static fetchLeaseContractProperties = params => api.post(urls.CONTRACTLISTING.LEASE_PROPERTIES, null, params);

  static downloadLeaseContract = appId => {
    const downloadAPI = new API(`${BASE_URL}`, null, {
      headers: {
        'Content-Type': 'application/octet-stream;charset=UTF-8',
      },
      responseType: 'blob',
    });
    return downloadAPI.get(urls.LEASE.APPLICATION_PDF_CONTRACT_PMA, appId);
  };
}

export default ContractService;
